import React from 'react';
import { LiveVideoCard, LiveVideoCardProps } from './LiveVideoCard';
import { Icon } from '@benzinga/core-ui';
import { UpcomingBroadcastCard, UpcomingBroadcastCardProps } from './UpcomingBroadcastCard';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import styled from '@benzinga/themetron';

export type { LiveVideoCardProps };

export interface BenzingaTVWidgetProps {
  id: string;
  subtitle?: string;
  title: string;
  upcomingBroadcasts: UpcomingBroadcastCardProps[];
}

export const BenzingaTVWidget: React.FC<BenzingaTVWidgetProps> = ({ id, title, upcomingBroadcasts }) => {
  return (
    <Container className="benzinga-tv-widget-container">
      <LiveVideoCard id={id} title={title} />
      <div className="upcoming-broadcasts-list">
        {upcomingBroadcasts.map(broadcast => (
          <UpcomingBroadcastCard key={broadcast.id} {...broadcast} />
        ))}
      </div>
      <div className="all-upcoming">
        <div className="all-upcoming-text">All upcoming streams</div>
        <Icon className="text-gray-500" icon={faChevronRight} />
      </div>
    </Container>
  );
};

const Container = styled.div`
  &.benzinga-tv-widget-container {
    overflow: hidden;
    border-radius: ${({ theme }) => theme.borderRadius.default};
    max-width: 96rem;
    width: 100%;

    .upcoming-broadcasts-list {
      display: flex;
      flex-direction: column;
      background-color: #f9fcff;
    }

    .all-upcoming {
      display: flex;
      align-items: center;
      background: white;
      border: 2px solid #CBE0F28;
      justify-content: space-between;
      border-radius: ${({ theme }) => theme.borderRadius.default};
      padding: 0.5rem 0.75rem;
      margin-top: 0.5rem;
    }

    .all-upcoming-text {
      color: ${({ theme }) => theme.colorPalette.gray800};
      font-weight: ${({ theme }) => theme.fontWeight.semibold};
      text-transform: uppercase;
    }
  }

  .live-video-card-container {
    height: 24rem;
  }
`;
